import React from 'react';
import AddAdvertisementAdminPage from './add-advertisement';

// This component reuses the AddAdvertisement component in edit mode
const EditAdvertisementAdminPage = () => {
  return <AddAdvertisementAdminPage />;
};

export default EditAdvertisementAdminPage;
